const Error = () => {
    return(
        <section className="error">
            <div className="wrapper">
                <h2>Looks like you have gotten lost...</h2>
                <p>Error 404 please navigate home through the logo in the top left corner.</p>
            </div>
        </section>
    )
}

export default Error;